import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState, } from 'react';

import dayjs from 'dayjs';


import { Menu as MainMenu } from '../../components/Menu';
import { ModelConsolidation } from '../../models/ModelConsolidation';

import { generateId } from '../../scripts/utils';

import { Box, Button, Divider, Typography, LinearProgress, FormControl, InputLabel, Select, MenuItem, } from '@mui/material';

import translations from '../../scripts/translations';

import { TierSelectBox } from '../../components/TierSelectBox';

import { getConsolidations, updateConsolidation, deleteConsolidation } from '../../api/сonsolidations';

import { CreatFieldComponent } from '../../components/Fields';

import { useData } from '../../hooks/DataProvider';

import Popup from '../../components/Popup';

import { ShipmentDirections, Files } from '../../scripts/configData';

import { getAsingeIdx, deleteAsingeIdx } from '../../api/asingne_idx.js';
import { getGenerateFiles } from '../../api/generate_files.js';


const Export = ({ language, consolidation_id, consolidationCode }) => {

    const btns = translations.button[language];
    const [_Files, _setFiles] = useState('');

    const handleChange = (event) => {
        const selectedFileKey = event.target.value;
        _setFiles('');

        getGenerateFiles({ consolidation_id, file: selectedFileKey, consolidationCode })
            .then((response) => {
                const disposition = response.headers['content-disposition'];
                let filename = 'download.xlsx';

                if (disposition) {
                    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }

                const blob = new Blob([response.data], {
                    type: response.headers['content-type'] || 'application/octet-stream'
                });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch((err) => {
                console.error('Error generating file:', err);
            });
    };


    return (
        <FormControl fullWidth>
            <InputLabel id="export-label" size='small'>{btns.exportFiles}</InputLabel>
            <Select
                labelId="export-label"
                id="export"
                value={_Files}
                label={btns.exportFiles}
                onChange={handleChange}
                size='small'
            >
                {Files.map((file, index) => (
                    <MenuItem key={index} value={file.key}>
                        {file[language]}
                    </MenuItem>
                ))}

            </Select>
        </FormControl >
    )

}


const Consolidation = () => {

    const navigate = useNavigate();
    const { consolidationId } = useParams();

    const { language } = useData();

    const [dataConsolidation, setDataConsolidation] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const [dataAsingeIdx, setDataAsingeIdx] = useState([]);

    const [statData, setStatData] = useState({
        totalShipments: 0,
        totalHandlingUnits: 0,
        totalChargeableWeight: 0,
        totalRevenue: 0,
        totalCost: 0,
        totalCommercialMargin: 0,
    });


    const [popupData, setPopupData] = useState({
        open: false,
        code: null,
        id: null,
        fn: null,
    });


    const btns = translations.button[language];
    const page = translations.pages.consolidation[language];


    const handleNew = (params = {}) => {

        const _id = generateId();
        const newConsolidation = {
            _id: _id,
            creationDate: dayjs().format('YYYY-MM-DD'),
            consolidationCode: 'new',
            shipmentDirection: ModelConsolidation.shipmentDirection.default,

            consignor: {},
            consignee: {},
            agent: {},
            carrier: {},

            origin: {},
            departureDate: '',

            destination: {},
            arrivalDate: '',

            internalRef: '',
            customerRef: '',

            prefix1: '',
            prefix2: '',

            numeroVol1: '',
            numeroVol2: '',

            serviceList: [],

            consolidationNote: '',

            shipmentOrderIds: []


        }
        // If params are provided, merge them into the new shipment
        Object.assign(newConsolidation, params);

        setDataConsolidation(newConsolidation);

    };

    const handleSave = () => {
        setIsLoadingButton(true);
        updateConsolidation(dataConsolidation).then(rs => {
            if (rs) {
                console.log('Consolidation saved successfully:', rs);
                navigate(`/consolidations/${rs._id}`);
            } else {
                console.error('Failed to save Consolidation');
            }
        }).catch(err => {
            console.error('Error saving Consolidation:', err);
        });
        setIsLoadingButton(false);
    }

    const handleDelete = () => {

        if (dataConsolidation._id && dataConsolidation._id !== 'new') {
            console.log('Deleting Consolidation:', dataConsolidation._id);
            deleteConsolidation(dataConsolidation._id).then(rs => {
                if (rs) {
                    console.log('Shipement deleted successfully:', rs);
                } else {
                    console.error('Failed to delete Shipement');
                }
            });
            setDataConsolidation({});
            navigate('/consolidations');
        }
    }

    const handleDeletePopup = () => {
        setPopupData({
            open: true,
            code: 'deleteConsolidationConfirmation',
            id: null,
            fn: handleDelete,
            types: {
                hasCancel: true,
                hasConfirm: true,
            }
        });
    };


    const handelDeleteAsingeIdx = (shipment_id) => {


        deleteAsingeIdx({ shipment_id: shipment_id, consolidation_id: dataConsolidation._id }).then(rs => {
            if (rs) {
                console.log('Assignment deleted successfully:', rs);
                setDataAsingeIdx(prev => { prev.filter(item => item.asingne_shipments[0]._id !== shipment_id) });
            } else {
                console.error('Failed to delete assignment');
            }
        }).catch(err => {
            console.error('Error deleting assignment:', err);
        });
    }



    useEffect(() => {
        if (consolidationId === 'new') {
            handleNew();
            setIsLoading(true);

        } else if (consolidationId && consolidationId !== 'new') {
            getConsolidations({ _id: consolidationId }).then(rs => {
                if (rs?.length > 0) {
                    let result = rs[0];
                    setDataConsolidation(result);
                    setIsLoading(false);
                }
            });
        }
        setIsLoading(false);
    }, [consolidationId]);


    useEffect(() => {
        if (dataConsolidation._id && dataConsolidation._id !== 'new') {
            getAsingeIdx({ consolidation_id: dataConsolidation._id }).then(rs => {
                if (rs) {
                    let shipments = rs.map(item => item.asingne_shipments[0]).sort((a, b) => {
                        return a.shipmentOrderCode - b.shipmentOrderCode
                    });

                    let totalShipments = 0
                    let totalHandlingUnits = 0
                    let totalChargeableWeight = 0
                    let totalRevenue = 0
                    let totalCost = 0
                    let totalCommercialMargin = 0;

                    for (let item of shipments) {
                        totalShipments += 1;
                        totalHandlingUnits += parseInt(item.totalHandlingUnits) || 0;
                        totalChargeableWeight += parseInt(item.soChargeableWeight) || 0;
                        totalRevenue += parseInt(item.revenue) || 0;
                        totalCost += parseInt(item.cost) || 0;
                        totalCommercialMargin += (parseInt(item.revenue) || 0) - (parseInt(item.cost) || 0);
                    }

                    setStatData({
                        totalShipments: totalShipments,
                        totalHandlingUnits: totalHandlingUnits,
                        totalChargeableWeight: totalChargeableWeight,
                        totalRevenue: totalRevenue,
                        totalCost: totalCost,
                        totalCommercialMargin: totalRevenue - totalCost,
                    });


                    setDataAsingeIdx(shipments);


                } else {
                    console.error('Failed to fetch assignment index data');
                }
            });
        } else {
            setDataAsingeIdx([]);
        }
    }, [dataConsolidation._id, dataAsingeIdx.length]);


    const sxDivider = {
        my: 2,
    };

    return (
        isLoading ? <LinearProgress /> : <>
            <MainMenu currentPage={'consolidations'} />

            <Box sx={{ display: 'grid', gridTemplateColumns: '.5fr .6fr .4fr .4fr .8fr', alignItems: 'center', gap: 1 }}>

                <Box>
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 2 }} >
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0 }} >
                            <Typography variant='subtitle1' sx={{ fontSize: '1rem', mr: 1 }} >{page.title} : </Typography>
                            <Typography variant='subtitle1' sx={{ fontSize: '1rem' }} color={dataConsolidation?.consolidationCode === 'new' ? 'warning' : 'primary'}  > {dataConsolidation?.consolidationCode}</Typography>
                        </Box>
                    </Box>
                </Box>

                <Typography variant='caption' sx={{ fontSize: '1rem', color: '#00000099' }} >
                    {ModelConsolidation?.creationDate[language]} : {dataConsolidation?.creationDate ? dayjs(dataConsolidation.creationDate).format('DD/MM/YYYY') : ''}
                </Typography>

                <CreatFieldComponent field={ModelConsolidation.shipmentDirection} data={dataConsolidation} updateData={setDataConsolidation} options={ShipmentDirections} />
                <Export language={language} consolidation_id={dataConsolidation._id} consolidationCode={dataConsolidation.consolidationCode} />
                <Box sx={{ display: 'flex', flexDirection: 'row-reverse', gap: 1 }} >
                    <Button variant='contained' loading={isLoadingButton} color='warning' onClick={handleSave}>{btns.save}</Button>
                    <Button variant='outlined' onClick={handleDeletePopup} disabled={dataConsolidation._id === 'new' ? true : false} color="secondary" >{btns.delete}</Button>
                    <Button variant='outlined' onClick={handleNew}>{btns.add}</Button>
                    {/* <Button variant='outlined' onClick={handleDuplicate} disabled={shipmentId === 'new' ? true : false} >{btns.duplicate}</Button> */}
                    {/* <Button variant='outlined' onClick={() => console.log(dataConsolidation)}>{btns.print}</Button> */}
                </Box>
            </Box>

            <Divider sx={sxDivider} />

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }} >
                <TierSelectBox model={ModelConsolidation} data={dataConsolidation} updateData={setDataConsolidation} type={'consignor'} />
                <Divider style={{ paddingTop: '0px' }} />
                <TierSelectBox model={ModelConsolidation} data={dataConsolidation} updateData={setDataConsolidation} type={'consignee'} />
                <Divider sx={{ m: 0 }} />
                <TierSelectBox model={ModelConsolidation} data={dataConsolidation} updateData={setDataConsolidation} type={'agent'} />
                <Divider sx={{}} />
                <TierSelectBox model={ModelConsolidation} data={dataConsolidation} updateData={setDataConsolidation} type={'carrier'} />
            </Box>

            <Divider sx={sxDivider} />

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }} >


                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 4fr', gap: 4 }} >
                    <CreatFieldComponent field={ModelConsolidation.departureDate} data={dataConsolidation} updateData={setDataConsolidation} />
                    <TierSelectBox model={ModelConsolidation} data={dataConsolidation} updateData={setDataConsolidation} type={'origin'} size={2} />
                </Box>



                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 4fr', gap: 4 }} >
                    <CreatFieldComponent field={ModelConsolidation.arrivalDate} data={dataConsolidation} updateData={setDataConsolidation} />
                    <TierSelectBox model={ModelConsolidation} data={dataConsolidation} updateData={setDataConsolidation} type={'destination'} size={2} />
                </Box>

                <Divider sx={{ m: 0 }} />

                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr .2fr .5fr .5fr', gap: 2 }} >
                    <CreatFieldComponent field={ModelConsolidation.internalRef} data={dataConsolidation} updateData={setDataConsolidation} />
                    <Box></Box>
                    <CreatFieldComponent field={ModelConsolidation.prefix1} data={dataConsolidation} updateData={setDataConsolidation} />
                    <CreatFieldComponent field={ModelConsolidation.numeroVol1} data={dataConsolidation} updateData={setDataConsolidation} />

                </Box>

                <Divider sx={{ m: 0 }} />

                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr .2fr .5fr .5fr', gap: 2 }} >

                    <CreatFieldComponent field={ModelConsolidation.customerRef} data={dataConsolidation} updateData={setDataConsolidation} />
                    <Box></Box>
                    <CreatFieldComponent field={ModelConsolidation.prefix2} data={dataConsolidation} updateData={setDataConsolidation} />
                    <CreatFieldComponent field={ModelConsolidation.numeroVol2} data={dataConsolidation} updateData={setDataConsolidation} />
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }} >
                    <Box sx={{ display: 'flex', justifyContent: 'space-around', gap: 2 }} >
                        <Typography variant='overline' color='#00000099' sx={{ mr: 5 }} >{page.note} :</Typography>
                        <Typography variant="button" color='red'>{page.totalShipments} : {statData.totalShipments}</Typography>
                        <Typography variant="button" color='red'>{page.totalHandlingUnits} : {statData.totalHandlingUnits}</Typography>
                        <Typography variant="button" color='red'>{page.totalChargeableWeight} : {statData.totalChargeableWeight}</Typography>
                        <Typography variant="button" color='red'>{page.totalRevenue} : {statData.totalRevenue}</Typography>
                        <Typography variant="button" color='red'>{page.totalCost} : {statData.totalCost}</Typography>
                        <Typography variant="button" color='red'>{page.totalCommercialMargin} : {statData.totalCommercialMargin}</Typography>


                    </Box>
                    <CreatFieldComponent field={ModelConsolidation.consolidationNote} data={dataConsolidation} updateData={setDataConsolidation} />
                </Box>

                <Divider sx={{ m: 0 }} />



                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }} >
                    <Typography variant='overline' color='#00000099' >{btns.shipments} :</Typography>
                    {
                        dataAsingeIdx.length > 0 && dataAsingeIdx.map((item, index) => {
                            return (<Box key={index}
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '.3fr 1fr 1fr .2fr .2fr .2fr .3fr .4fr',
                                    gridTemplateRows: 'auto',
                                    gridAutoFlow: 'column',
                                    alignItems: 'center',
                                    gap: 1,
                                    border: '1px solid #00000022',
                                    borderRadius: 1, p: 1
                                }} >
                                <Typography variant='body2'>{item.shipmentOrderCode}</Typography>
                                {/* <Typography variant='body2'>{item.creationDate ? dayjs(item.creationDate).format('DD/MM/YYYY') : ''}</Typography> */}
                                <Typography variant='body2' noWrap>{item.consignor?.name}</Typography>
                                <Typography variant='body2' noWrap>{item.consignee?.name}</Typography>
                                {/* <Typography variant='body2'>{item.consignor?.consignee}</Typography> */}
                                <Typography variant='body2'>{item.mrn ? 'MRN' : ""}</Typography>
                                <Typography variant='body2'>{item.totalHandlingUnits}</Typography>
                                <Typography variant='body2'>{item.soChargeableWeight}</Typography>
                                <Button variant='outlined' size='small' onClick={() => {
                                    navigate(`/shipments/${item._id}`);
                                }} >{btns.open}</Button>
                                <Button variant='outlined' size='small' onClick={() => {
                                    setPopupData({
                                        open: true,
                                        code: 'deleteAsingneIdxConfirmation',
                                        id: item._id,
                                        fn: () => handelDeleteAsingeIdx(item._id),
                                        types: {
                                            hasCancel: true,
                                            hasConfirm: true,
                                        }
                                    });
                                }} >{btns.delete}</Button>

                            </Box>)
                        })
                    }
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }} ></Box>


            </Box>

            {/* <CreatFieldComponent field={ModelShipment.revenue} data={dataShipement} updateData={setDataShipement} disabledInForm /> */}



            {/* Footer */}
            {popupData.open && <Popup popupData={popupData} setPopupData={setPopupData} />}
        </>
    )
}

export default Consolidation;






// serviceList: [],

// consolidationNote: '',